const namedRoutes = {
  home: "/",
  notFound: "/404/",
  about: "/about/",
  alternatorChargers: "/alternator-chargers/",
  deals: "/deals/",
  powerSystems: "/power-systems/vanlife/",
  ecoflow: {
    vanlife: "/ecoflow/vanlife/",
    d3air: "/ecoflow/delta-3-air-series-1000-2000/",
    titanSeries: "/ecoflow/titan-5000-series/",
    delta4: {
      series: "/ecoflow/delta-4-series/",
    },
    dp: "/ecoflow/delta-pro/",
    dp3: "/ecoflow/delta-pro-3/",
    d3maxPlus: "/ecoflow/delta-3-max-plus/",
    d3ultraPlus: "/ecoflow/delta-3-ultra-plus/",
    altCharger: {
      transit: "/install-guide/ecoflow-alternator-charger-ford-transit/",
      quick: "/ecoflow/alternator-chargers/800w-500w/overview/",
      review: "/ecoflow/alternator-chargers/800w-500w/",
      gen1Compatibility: "/ecoflow/alternator-chargers/800w-500w/compatibility/",
      gen1CableGuide: "/ecoflow/alternator-chargers/800w-500w/cable-port-guide/",
      gen2: "/ecoflow/alternator-chargers/600w-1000w/",
      gen2Compatibility: "/ecoflow/alternator-chargers/600w-1000w/compatibility/",
      gen2CableGuide: "/ecoflow/alternator-chargers/600w-1000w/cable-port-guide/",
    },
    batteryCompatibility: "/ecoflow/battery-compatibility/",
    wiring12v: "/ecoflow/12v-wiring/",
    deltaProUltra: {
      xt60Compatibility: "/ecoflow/delta-pro-ultra/xt60-compatibility/",
    },
  },
  bluetti: {
    vanlife: "/bluetti/vanlife/",
    rv5: "/bluetti/rv5/",
    charger2: {
      review: "/bluetti/charger-2/",
      compatibility: "/bluetti/charger-2/compatibility/",
    },
    charger1: {
      review: "/bluetti/charger-1/",
      compatibility: "/bluetti/charger-1/compatibility/",
    },
    ac200l: "/bluetti/ac200l/",
    apex200: "/bluetti/apex-200/",
    altCharger: {
      transit: "/install-guide/bluetti-alternator-charger-ford-transit/",
    },
  },
  jackery: {
    vanlife: "/jackery/vanlife/",
  },
  inventory: {
    vanlife: "/inventory/vanlife/",
  },
  velit: {
    heater: "/velit/heater/4000p/",
  },
  privacy: "/privacy/",
  terms: "/terms/",
  affiliate: "/affiliate/",
  links: {
    contact: "https://forms.gle/DZMxA19ikY8a599PA",
    facebook: "https://www.facebook.com/TysonsGearLab/",
    instagram: "https://www.instagram.com/tysonsgearlab/",
    youtube: "https://www.youtube.com/@TysonsGearLab",
  },
};

export default namedRoutes;
